import React from "react";
import {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {
    Alert, Button,
    Card, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Fab, Grid,
    IconButton,
    Snackbar
} from "@mui/material";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import styles from "../../../assets/css/page.module.scss";
import CustomTable from "../../../components/subComponents/Table";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import {TextField} from "../../../components/subComponents/TextField";
import LoadingButton from "../../../components/subComponents/LoadingButton";
import {styled} from "@mui/material/styles";
import {BenefitApi} from "../../../utils/BenefitApi";

const fabStyle = {
    position: 'absolute',
    top: 30,
    right: 30,
};
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const Input = styled('input')({
    display: 'none',
});
const Benefit = (props) => {
    const params = useParams();
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [openSnackBar1, setOpenSnackBar1] = useState(false);
    const [message, setMessage] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [sending, setSending] = useState(false);
    const sendDataToServer = async () => {
        setSending(true);
        if (params.id) {
            const update = async () => {
                let fd = new FormData();
                fd.append("payload", JSON.stringify({
                    title: title,
                    description: description,
                }));
                await BenefitApi.updateBenefit(fd, params.id,
                    async (result) => {
                        handleClickSnackBar1("ویژگی بروزرسانی شد.");
                        await sleep(3000);
                        setSending(false);
                        navigate("/admin/benefit");
                        fetchData();

                    },
                    (error) => {
                        setSending(false);

                    });
            }
            await update();
        } else {
            const insert = async () => {
                let fd = new FormData();
                fd.append("payload", JSON.stringify({
                    title: title,
                    description: description,
                }));
                await BenefitApi.insertBenefit(fd,
                    async (result) => {
                        handleClickSnackBar1("ویژگی افزوده شد.");
                        await sleep(3000);
                        setSending(false);
                        handleClose();
                        fetchData();
                    },
                    (error) => {
                        setSending(false);

                    });
            }
            await insert();
        }

    }

    const handleClickSnackBar1 = (text) => {
        setOpenSnackBar1(true);
        setMessage(text);
    };
    const handleClose = () => {
        setOpenDialog(false);
    };
    const handleCloseSnackBar1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar1(false);
    };



    const deleteBenefit = async (id) => {
        setDataLoading(true);
        await BenefitApi.deleteBenefit(id, () => {
            handleClickSnackBar1('ویژگی حذف شد!');
            fetchData();

        }, () => {
        });
    }
    const fetchData = async () => {
        setDataLoading(true);
        await BenefitApi.getAllBenefit(
            (result) => {
                setRows(result.data);
                setDataLoading(false);
            },
            (error) => {
                setDataLoading(false);

            });

    }
    const headers = [
        {
            field: 'title', title: 'عنوان', width: 250, renderCell: (row) => (
                <div>
                    <Link to={`/admin/benefit/${row.id}`}>{row.title}</Link>
                </div>
            ),
        },



        {
            field: 'userStatus', title: '---', width: 200,
            align: 'right',
            renderCell: (row) => (
                <>
                    <IconButton color="error" component="button" onClick={() => {
                        (async () => {
                            await deleteBenefit(row.id);
                        })();
                    }}>
                        <DeleteOutlineRoundedIcon/>
                    </IconButton>

                </>)
        },


    ];

    const getBenefit = async (id) => {
        await BenefitApi.getBenefit(id, (result) => {
            setTitle(result.data.title);
            setDescription(result.data.description);

        }, (error) => {
        })
    }

    useEffect(() => {
        (async () => {
            await fetchData();
        })();


    }, []);
    useEffect(() => {
        if (params.id) {
            (async () => {
                await getBenefit(params.id);
            })();
        } else {
            setTitle("");
            setDescription("");
        }
    }, [params.id]);

    return <div style={{padding: 15}}>
        <Card elevation={3} style={{height: 'calc(100vh - 30px)', direction: "rtl", overflow: "hidden"}}>
            <div className={styles.container}>
                <CustomTable headers={headers} rows={rows} loading={dataLoading} bottom={0}/>

            </div>
        </Card>
        <Dialog
            fullWidth
            maxWidth={"md"}
            open={(openDialog || params.id)}
            onClose={handleClose}
        >
            <DialogTitle>{params.id ? 'بروزرسانی ویژگی' : 'ایجاد ویژگی جدید'}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                </DialogContentText>
                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item xs={6}>
                                <div className={styles.inputContainer}>
                                    <TextField label="نام" variant="outlined"
                                               value={title}
                                               onChange={e => {
                                                   setTitle(e.target.value)
                                               }}
                                               fullWidth
                                    />
                                </div>
                                <div className={styles.inputContainer}>

                                    <TextField label="شرح" variant="outlined"
                                               multiline
                                               rows={10}
                                               value={description}
                                               onChange={e => {
                                                   setDescription(e.target.value)
                                               }}
                                               fullWidth

                                    />
                                </div>
                            </Grid>




                        </Grid>


                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button color="error" onClick={() => {
                    if (params.id)
                        navigate(-1);
                    else handleClose();
                }}>
                    انصراف
                </Button>

                <LoadingButton
                    loading={sending}
                    loadingPosition="end"
                    variant={'text'}
                    color="primary"
                    component="button"
                    onClick={() => {
                        sendDataToServer();
                    }}
                >
                    ثبت
                </LoadingButton>
            </DialogActions>
        </Dialog>
        <Snackbar open={openSnackBar1} autoHideDuration={2000}
                  onClose={handleCloseSnackBar1}
                  className={styles.snackBar}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        >
            <Alert
                severity="success"
                className={styles.txt}
            >
                {message}
            </Alert>
        </Snackbar>

        <Fab sx={fabStyle} color="primary" onClick={() => {
            setOpenDialog(true)
        }}>
            <AddRoundedIcon/>
        </Fab>
    </div>;
}

export default Benefit;